import { useContext } from "react";
import AuthContext from "@/react/context/authContext.jsx";
import MySwivuBoards from "@/react/components/MySwivu/MySwivuBoards.jsx";

export default function MySwivuPage() {
  const { user } = useContext(AuthContext);

  return (
    <>
      {user && <MySwivuBoards />}
    </>
  );
}
